// 全局弹框（兼容三方登录成功/失败回调的逻辑）
'use client';

import useThirdPartyLogin from '@/hooks/useThirdPartyLogin';
import { EPlatform } from '@/utils/enums/platform-enum';
import dynamic from 'next/dynamic';
import { useEffect, useState } from 'react';
const NormalDialog = dynamic(() => import('./NormalDialog'), {
  ssr: false,
});
const Loading = dynamic(() => import('./Loading'), {
  ssr: false,
});

export default function GlobalDialogs({ deviceType }: { deviceType: EPlatform }) {
  const { checkThirdLogin } = useThirdPartyLogin();
  const [showDialog, setShowDialog] = useState(false);

  useEffect(() => {
    // 检查三方登录
    checkThirdLogin().then(() => {
      setShowDialog(true);
    });
  }, []);

  return (
    <>
      {showDialog && <NormalDialog />}
      <Loading deviceType={deviceType} />
    </>
  );
}
